module.exports = require("@gauzy/plugin-job-search");